import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  select() {
    const slotSelector = document.getElementById('slot_selector')
    slotSelector.innerHTML = '⏳ Atualizando...'
    slotSelector.classList.add('disabled', 'my-2', 'pointer-events-none')
  }
}
